import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  printIssueLinkClass: {
    textDecoration: 'underline',
  },
});
